import React from 'react';
var AsyncCustomOption = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/user-picker/custom-option" */'./main').then(function (module) {
    return {
      default: module.CustomOption
    };
  });
});
export default AsyncCustomOption;